// Generated by purs version 0.13.8
"use strict";
var Data_Enum = require("../Data.Enum/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Typelevel_Num_Sets = require("../Data.Typelevel.Num.Sets/index.js");
var Data_Unfoldable1 = require("../Data.Unfoldable1/index.js");
var Extra_Math = require("../Extra.Math/index.js");
var Clockwise = (function () {
    function Clockwise() {

    };
    Clockwise.value = new Clockwise();
    return Clockwise;
})();
var Widdershins = (function () {
    function Widdershins() {

    };
    Widdershins.value = new Widdershins();
    return Widdershins;
})();
var Direction = function (x) {
    return x;
};
var showDireciton = new Data_Show.Show(function (v) {
    if (v === 0) {
        return "right";
    };
    if (v === 1) {
        return "upRight";
    };
    if (v === 2) {
        return "up";
    };
    if (v === 3) {
        return "upLeft";
    };
    if (v === 4) {
        return "left";
    };
    if (v === 5) {
        return "downLeft";
    };
    if (v === 6) {
        return "down";
    };
    return "downRight";
});
var semigroupDirection = Extra_Math.semigroupzn(Data_Typelevel_Num_Sets.posD8);
var monoidDirecton = Extra_Math.monoidzn(Data_Typelevel_Num_Sets.posD8);
var groupDirecton = Extra_Math.groupzn(Data_Typelevel_Num_Sets.posD8);
var fromInt = function (x) {
    return Extra_Math.zn(Data_Typelevel_Num_Sets.posD8)(x);
};
var left = fromInt(4);
var opposite = function (d) {
    return Data_Semigroup.append(semigroupDirection)(fromInt(4))(d);
};
var right = fromInt(0);
var rotate4 = function (v) {
    return function (d) {
        if (v instanceof Widdershins) {
            return Data_Semigroup.append(semigroupDirection)(fromInt(2))(d);
        };
        if (v instanceof Clockwise) {
            return Data_Semigroup.append(semigroupDirection)(fromInt(6))(d);
        };
        throw new Error("Failed pattern match at Framework.Direction (line 67, column 1 - line 67, column 42): " + [ v.constructor.name, d.constructor.name ]);
    };
};
var rotate8 = function (v) {
    return function (d) {
        if (v instanceof Widdershins) {
            return Data_Semigroup.append(semigroupDirection)(fromInt(1))(d);
        };
        if (v instanceof Clockwise) {
            return Data_Semigroup.append(semigroupDirection)(fromInt(7))(d);
        };
        throw new Error("Failed pattern match at Framework.Direction (line 71, column 1 - line 71, column 42): " + [ v.constructor.name, d.constructor.name ]);
    };
};
var up = fromInt(2);
var upLeft = fromInt(3);
var upRight = fromInt(1);
var eqDirection = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Extra_Math.eqzn(Data_Typelevel_Num_Sets.posD8))(x)(y);
    };
});
var ordDirection = new Data_Ord.Ord(function () {
    return eqDirection;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Extra_Math.ordzn(Data_Typelevel_Num_Sets.posD8))(x)(y);
    };
});
var enumDirection = Extra_Math.enumZn(Data_Typelevel_Num_Sets.posD8);
var downRight = fromInt(7);
var downLeft = fromInt(5);
var down = fromInt(6);
var unMove = function (p) {
    return function (q) {
        var v = Data_Ring.sub(Extra_Math.ringVector(Data_Ring.ringInt))(q)(p);
        if (v.x === 1 && v.y === 0) {
            return new Data_Maybe.Just(right);
        };
        if (v.x === 1 && v.y === -1) {
            return new Data_Maybe.Just(upRight);
        };
        if (v.x === 0 && v.y === -1) {
            return new Data_Maybe.Just(up);
        };
        if (v.x === -1 && v.y === -1) {
            return new Data_Maybe.Just(upLeft);
        };
        if (v.x === -1 && v.y === 0) {
            return new Data_Maybe.Just(left);
        };
        if (v.x === -1 && v.y === 1) {
            return new Data_Maybe.Just(downLeft);
        };
        if (v.x === 0 && v.y === 1) {
            return new Data_Maybe.Just(down);
        };
        if (v.x === 1 && v.y === 1) {
            return new Data_Maybe.Just(downRight);
        };
        return Data_Maybe.Nothing.value;
    };
};
var directions8 = Data_Enum.upFromIncluding(enumDirection)(Data_Unfoldable1.unfoldable1Array)(right);
var directions4 = [ right, up, left, down ];
var dirVector = function (dictRing) {
    return function (v) {
        if (v === 0) {
            return {
                x: Data_Semiring.one(dictRing.Semiring0()),
                y: Data_Semiring.zero(dictRing.Semiring0())
            };
        };
        if (v === 1) {
            return {
                x: Data_Semiring.one(dictRing.Semiring0()),
                y: Data_Ring.negate(dictRing)(Data_Semiring.one(dictRing.Semiring0()))
            };
        };
        if (v === 2) {
            return {
                x: Data_Semiring.zero(dictRing.Semiring0()),
                y: Data_Ring.negate(dictRing)(Data_Semiring.one(dictRing.Semiring0()))
            };
        };
        if (v === 3) {
            return {
                x: Data_Ring.negate(dictRing)(Data_Semiring.one(dictRing.Semiring0())),
                y: Data_Ring.negate(dictRing)(Data_Semiring.one(dictRing.Semiring0()))
            };
        };
        if (v === 4) {
            return {
                x: Data_Ring.negate(dictRing)(Data_Semiring.one(dictRing.Semiring0())),
                y: Data_Semiring.zero(dictRing.Semiring0())
            };
        };
        if (v === 5) {
            return {
                x: Data_Ring.negate(dictRing)(Data_Semiring.one(dictRing.Semiring0())),
                y: Data_Semiring.one(dictRing.Semiring0())
            };
        };
        if (v === 6) {
            return {
                x: Data_Semiring.zero(dictRing.Semiring0()),
                y: Data_Semiring.one(dictRing.Semiring0())
            };
        };
        return {
            x: Data_Semiring.one(dictRing.Semiring0()),
            y: Data_Semiring.one(dictRing.Semiring0())
        };
    };
};
var move = function (dictRing) {
    return function (d) {
        return function (v) {
            return Data_Semiring.add(Extra_Math.semiringVector(dictRing.Semiring0()))(v)(dirVector(dictRing)(d));
        };
    };
};
var boundedEnumDirection = Extra_Math.boundedEnumZn(Data_Typelevel_Num_Sets.posD8);
var boundedDirection = Extra_Math.boundedZn(Data_Typelevel_Num_Sets.posD8);
module.exports = {
    Clockwise: Clockwise,
    Widdershins: Widdershins,
    Direction: Direction,
    right: right,
    upRight: upRight,
    up: up,
    upLeft: upLeft,
    left: left,
    downLeft: downLeft,
    down: down,
    downRight: downRight,
    directions4: directions4,
    directions8: directions8,
    fromInt: fromInt,
    rotate4: rotate4,
    rotate8: rotate8,
    opposite: opposite,
    dirVector: dirVector,
    move: move,
    unMove: unMove,
    showDireciton: showDireciton,
    eqDirection: eqDirection,
    ordDirection: ordDirection,
    enumDirection: enumDirection,
    boundedDirection: boundedDirection,
    boundedEnumDirection: boundedEnumDirection,
    semigroupDirection: semigroupDirection,
    monoidDirecton: monoidDirecton,
    groupDirecton: groupDirecton
};
